import toast from "react-hot-toast";
import { FetchError } from "./project-request";
import { errorPageData, ErrorVariant, ErrorVariantEnum } from "../assets/utils/enums/error-page";
import CustomToast from "../components/ui/custom-toast";
import { ToastTypeEnum } from "../assets/utils/enums/toast";

export default function handleErrorData(error: FetchError, setErrorStatus: React.Dispatch<React.SetStateAction<ErrorVariantEnum | null>>) {
  if (error.status === 401 || error.status === 403) {
    setErrorStatus(ErrorVariantEnum.FORBIDDEN);
    toast((t) => (
      <CustomToast
        t={t}
        text={errorPageData[ErrorVariantEnum.FORBIDDEN].description}
        type={ToastTypeEnum.ERROR}
      />
    ));
    return;
  }

  if (error.status === 404 || error.status === 204) {
    setErrorStatus(ErrorVariantEnum.NOT_FOUND);
    toast((t) => (
      <CustomToast
        t={t}
        text={errorPageData[ErrorVariantEnum.NOT_FOUND].description}
        type={ToastTypeEnum.ERROR}
      />
    ));
    return;
  }

  setErrorStatus(ErrorVariantEnum.SERVER);
  toast((t) => (
    <CustomToast
      t={t}
      text={errorPageData[ErrorVariantEnum.SERVER].description}
      type={ToastTypeEnum.ERROR}
    />
  ));

}

export function handleApiError(error: FetchError) {
  let codeError: ErrorVariant = ErrorVariantEnum.NOT_FOUND;
  switch (error.status) {
    // case 401:
    //   // refresh вже пробувався, тут — logout
    //   store.dispatch(clearAccessToken());
    //   window.location.href = "/login";
    //   break;

    case 403: case 401:
      codeError = ErrorVariantEnum.FORBIDDEN;
      break;

    case 404:
    case 204:
      codeError = ErrorVariantEnum.EMPTY;
      break;

    case 500:
      codeError = ErrorVariantEnum.SERVER;
      break;

    default:
      codeError = ErrorVariantEnum.UNKNOWN;
  }

  return toast((t) => (
    <CustomToast
      t={t}
      text={errorPageData[codeError].title}
      type={ToastTypeEnum.ERROR}
    />
  ));
}
